const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

$(".card__content .lsp_var img").each((i, e) => {
  var parents = $(e).parents(
    ".card-wrapper.product-card-wrapper.underline-links-hover"
  );
  var slider = parents.find(".sec_slider_div");
  slider.slick("slickUnfilter");
  if (slider.find(`.slick-slide[data-color="${$(e).attr("vf")}"]`).length) {
    slider.slick("slickFilter", function customFilter() {
      return (
        $(this).data("color") === $(e).attr("vf") ||
        $(this).data("color") === ""
      );
    });
  }
});

$(".card__content .lsp_var img").click(function () {
  $(this)
    .parent()
    .addClass("active_size")
    .siblings()
    .removeClass("active_size");
  var ss = $(this).attr("vf");
  var tt = $(this)
    .parents(".card--standard.card--media")
    .find(".card__inner .size_lsp .active_size")
    .attr("tr");
  let id = $(
    '.card__content .vari_hide_loop .Hide_lopping[hid="' +
      tt +
      " " +
      "/" +
      " " +
      ss +
      '"]'
  ).attr("data-id");
  console.log(ss, tt, id);
  $(this)
    .parents(".card.card--standard.card--media")
    .find("button#Collection_addtocard")
    .attr("newid", id);

  var color = $(this).attr("vf");
  if (color.length) {
    var parents = $(this).parents(
      ".card-wrapper.product-card-wrapper.underline-links-hover"
    );
    var slider = parents.find(".sec_slider_div");
    slider.slick("slickUnfilter");
    if (slider.find(`.slick-slide[data-color="${color}"]`).length) {
      slider.slick("slickFilter", function customFilter() {
        return $(this).data("color") === color || $(this).data("color") === "";
      });
    }
  }
  $(".fluid_img1").show();
});

$(".card__inner ul.size_lsp li").click(function () {
  $(this).addClass("active_size").siblings().removeClass("active_size");
  var ss = $(this).attr("tr");
  var tt = $(this)
    .parents(".card--standard.card--media")
    .find(".card__content .lsp_var.swiper-slide-active")
    .attr("vf");
  let id = $(
    '.card__content .vari_hide_loop .Hide_lopping[hid="' +
      ss +
      " " +
      "/" +
      " " +
      tt +
      '"]'
  ).attr("data-id");
  $(".card__inner button#Collection_addtocard").attr("newid", id);

  if (
    $(this)
      .parents(".card__inner")
      .find(".product_size")
      .hasClass("add_cart_product")
  ) {
    var free_id = $(this)
      .parents(".card__inner")
      .find('span[data-title="' + ss + '"]')
      .text();
    $(this).parents(".card__inner").find(".another_id").text(free_id);
  }
});

$(document).on(
  "click",
  ".product-card-wrapper button#Collection_addtocard",
  function (event) { 
    $(".drawer").removeClass("is-empty");
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    event.preventDefault();
    var arr = [];
    if ($(this).hasClass("add_cart_product")) {
      var id1 = $(this).attr("newid");
      var id2 = $(this).parents(".lsp_options").find(".another_id").text();
      arr.push({ id: id1, quantity: 1, properties: { varid: id2 } });
      
      arr.push({ id: id2, quantity: 1 });
      console.log(arr);
      $.ajax({
        type: "GET",
        url: "/cart/add.js",
        data: {
          items: arr,
          sections: cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        },
        dataType: "json",
        success: function (response) {
          cart.renderContents(response);
        },
        error: function () {
          console.log("error");
        },
      });
    } else {
      var id = $(this).attr("newid");
      console.log(id, "id");
      arr.push({ id: id, quantity: 1 });
      console.log(arr);
      $.ajax({
        type: "GET",
        url: "/cart/add.js",
        data: {
          items: arr,
          sections: cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        },
        dataType: "json",
        success: function (response) {
          cart.renderContents(response);
        },
        error: function () {
          console.log("error");
        },
      });
    }
  }
);

$(function () {
  $(".btn.lsp_item").click(function () {
    let text = $(this).text().toLowerCase();
    $(`[collection_name="${text}"]`)
      .parent()
      .find('[name="filter.p.product_type"]')
      .click();
  });
});
